import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nvr-blocked-content-dialog',
  templateUrl: './blocked-content-dialog.component.html',
  styleUrls: ['./blocked-content-dialog.component.scss'],
})
export class BlockedContentDialogComponent implements OnInit {
  public dialogText = {
    title: 'Warning',
    contentLine1: 'It looks like you’re using some ad blocking software that may not allow the migration tool to function properly.',
    contentLine2: 'To continue, please disable ad blocking then refresh the page.',
    confirm: 'OK',
  }

  constructor() { }

  ngOnInit(): void {
  }

}
